import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { ModalComponent, ModalStyle } from '../../../../centrui/src/app/components/modal/modal.component';
import { ModalService } from '../../../../centrui/src/app/services/modal.service';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { Observable } from 'rxjs';
import { CentruiButtonComponent } from '../../../../centrui/src/app/components/centrui-button/centrui-button.component';
import { CentruiSpinnerComponent } from '../../../../centrui/src/app/components/centrui-spinner/centrui-spinner.component';
import { AuthService } from '../../../../centrui/src/app/services/auth.service';
import { User } from '../../../models/User';
import { ApiService } from '../../../../centrui/src/app/services/api.service';
import { NgIf } from '@angular/common';
import { NgForOf } from '@angular/common';
import { CentruiAvatarComponent } from '../../../../centrui/src/app/components/centrui-avatar/centrui-avatar.component';
import { NotifierService } from '../../../../centrui/src/app/services/notifier.service';

@Component({
  selector: 'app-agency-profiles',
  imports: [
    CentruiButtonComponent,
    CentruiSpinnerComponent,
    NgIf,
    NgForOf,
    CentruiAvatarComponent,
  ],
  templateUrl: './agency-profiles.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agency-profiles.component.scss'
})
export class AgencyProfilesComponent extends ModalComponent {

  agencyManager!: User;

  agencyProfiles: User[] = [];

  selectedUser: User | null = null;

  loading = false;

  manageProfilesHandler?: (agencyManager: User) => Observable<unknown>;

  get canManageProfiles(): boolean {
    return !!this.manageProfilesHandler;
  }

  constructor(
    public override modalService: ModalService,
    public override ngxSmartModalService: NgxSmartModalService,
    public authService: AuthService,
    private apiService: ApiService,
    private notifierService: NotifierService,
  ) {
    super(modalService, ngxSmartModalService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.agencyManager = (this.authService.userObject as User);
    this.getAgencyProfiles();
  }

  getAgencyProfiles() {
    this.loading = true;
    this.apiService.get(User, {
      filters: [
        { key: 'license_id', value: this.agencyManager.license!.id },
        { key: 'id', value: this.agencyManager.id, not: true },
        { key: 'is_agency', value: 1 },
      ]
    }).subscribe((response: any[]) => {
      this.agencyProfiles = response as User[];
      this.loading = false;
    });
  }

  selectUser(user: User): void {
    this.modalService.open(ModalComponent, {
      title: 'Confirm profile selection',
      text: 'Continue as ' + user.name + '?',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
    }).subscribe((result: NgxSmartModalComponent) => {
      if (result.hasData() && result.getData()) {
        this.selectedUser = user;
        this.authService.agencyLogin(user).subscribe(response => {
          this.notifierService.notifyResponse(response);
          this.close(true);
        });
      }
    });
  }

  getInitials(name: string): string {
    if (!name) return '';
    const parts = name.split(' ').filter(part => part.length > 0);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0]?.[0]?.toUpperCase() || '';
  }

  isDefaultAvatar(file: string): boolean {
    return file === '/assets/img/avatar.svg';
  }

  createUser(): void {

  }

  cancel() {
    this.modalService.open(ModalComponent, {
      title: 'Confirm logout',
      text: 'Are you sure you want to logout?',
      confirmButtonText: 'Logout',
      cancelButtonText: 'Cancel',
      style: ModalStyle.DANGER
    }).subscribe((result: NgxSmartModalComponent) => {
      if (result.hasData() && result.getData()) {
        this.close(true);
        this.authService.logout().subscribe(response => {
          this.notifierService.notifyResponse(response);
        });
      }
    });
  }

  launchManageAgencyProfilesModal(): void {
    this.manageProfilesHandler?.(this.agencyManager).subscribe(() => {
      this.getAgencyProfiles();
    });
  }
}
